<template>

  <div>

    <div class="mb-3">
      {{ $t('You can add questions to be filled in the application by the candidates.') }}
    </div>
    
    <div class="mb-3">
      <TemplateapplySelect @setTemplate="setTemplate" />
    </div>

    <div class="card">
      <div class="card-body">
        <div
          class="list-form" 
          v-sortable="{ handle: '.sortable-move', items: job.application_questions}">
          <div
            class="card"
            v-for="(question, question_index) in job.application_questions"
            :key="question_index">
            
            <div class="card-header">
              <div class="d-flex justify-content-between">
                <div class="mr-auto"><a href="javascript:void(0)" class="sortable-move"><i class="fas fa-arrows-alt" /></a></div>
                <div class="pr-3"><input type="checkbox" id="inlineFormCheck" v-model="question.required"> {{ $t('Required') }}</div>
                <div><a href="javascript:void(0)" @click="removeItem(question_index)">{{ $t('Remove') }}</a></div>
              </div>
            </div>

            <div class="card-body">
              <div class="form-group">
                <input type="text" class="form-control" :placeholder="$t('Question')" v-model="question.label">
                <ValidateMessage :error="validateErrors['application_questions.' +question_index+ '.label']" />
              </div>
              <div class="form-group">
                <select type="text" class="form-control" v-model="question.type">
                  <option value="text">{{ $t('Short text') }}</option>
                  <option value="textarea">{{ $t('Long text') }}</option>
                  <option value="radio">{{ $t('List of options (Single choice)') }}</option>
                  <option value="checkbox">{{ $t('List of options (Multiple choice)') }}</option>
                  <option value="boolean">{{ $t('Yes or no') }}</option>
                </select>
                <ValidateMessage :error="validateErrors['application_questions.' +question_index+ '.type']" />
              </div>

              <div v-if="question.type === 'boolean'">
                <input type="checkbox" v-model="question.disqualify">
                {{ $t('Disqualify candidate if answer is "no"') }}
                <ValidateMessage :error="validateErrors['application_questions.' +question_index+ '.disqualify']" />
              </div>

              <div v-if="question.type === 'radio' || question.type === 'checkbox'">
                <ul
                  class="form-items"
                  v-sortable="{ handle: '.move', items: question.options}">
                  <li
                    v-for="(option, option_index) in question.options">
                    <div><a href="javascript:void(0)" class="move text-secondary"><i class="fas fa-arrows-alt" /></a></div>
                    <div class="form-items-input">
                      <input 
                        type="text" 
                        :placeholder="$t('Alternative')" 
                        v-model="question.options[option_index]">
                      <ValidateMessage :error="validateErrors['application_questions.' + question_index + '.options.' + option_index]" />
                    </div>
                    <div><a href="javascript:void(0)" @click="removeOption(question, option_index)" class="text-secondary"><i class="fas fa-times" /></a></div>
                  </li>
                </ul>
                <ValidateMessage :error="validateErrors['application_questions.' + question_index + '.options']" />
                <br>
                <a href="javascript:void(0)"  @click="addOption(question.options)">Adicionar opção</a>
              </div>

            </div>

          </div>
        </div>

        <div><a href="javascript:void(0)" @click="addItem()">{{ $t('Add question') }}</a></div>
      </div>
    </div>

    <!--<div
      v-if="needApplicationDisqualifyEmail"
      class="mt-4">
      <h5>Mensagem de desclassificação automática</h5>
      <p>Configure uma mensagem automática adicionando uma ação "Ao desclassificar" na etapa "Candidatura".</p>
    </div>-->

    <div
      v-if="needApplicationDisqualifyEmail"
      class="mt-4">
      <h5 class="mt-4">Mensagem de desclassificação</h5>
      <p>Configure uma mensagem automática de desclassificação para candidatos eliminados nas perguntas da candidatura.</p>
      <div v-if="needApplicationDisqualifyEmail" class="mt-3">
        <div class="form-group">
          <div class="form-check">
            <input
              class="form-check-input"
              type="checkbox"
              id="gdpr"
              v-model="job.application_disqualify_email.enabled">
            <label
              class="form-check-label"
              for="gdpr">
                Enviar mensagem ao desclassificar
              </label>
          </div>
          <ValidateMessage :error="validateErrors['application_disqualify_email.enabled']" />
        </div>
        <div v-if="job.application_disqualify_email.enabled">
          <div class="form-group">
            <label>{{ $t('Template') }}</label>
            <SelectTemplatemail v-model="job.application_disqualify_email.templatemail_id" />
            <ValidateMessage :error="validateErrors['application_disqualify_email.templatemail_id']" />
          </div>
          <div class="form-group">
            <label>{{ $t('Delay') }}</label>
            <DelayRelativeForm v-model="job.application_disqualify_email.delay" />
            <ValidateMessage :error="validateErrors['application_disqualify_email.delay']" />
            <ValidateMessage :error="validateErrors[`application_disqualify_email.delay.due_time`]" />
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import _ from 'lodash'
import TemplateapplySelect from '@/components/Parts/TemplateapplySelect'
import DelayRelativeForm from '@/components/Parts/DelayRelativeForm'
import SelectTemplatemail from '@/components/Fields/SelectTemplatemail'
import SelectUser from '@/components/Fields/SelectUser'

export default {
  name: 'JobFormQuestions',
  components: {
    TemplateapplySelect,
    DelayRelativeForm,
    SelectTemplatemail,
    SelectUser
  },
  props: [
    'initJob',
    'validateErrors'
  ],
  data () {
    const job = this.$clone(this.initJob)
    const applicationQuestions = _.get(job, 'application_questions')
    const applicationDisqualifyEmail = _.get(job, 'application_disqualify_email')

    return {
      job: {
        ...job,
        application_questions: applicationQuestions || [],
        application_disqualify_email: applicationDisqualifyEmail || { enabled: false }
      }
    }
  },
  watch: {
    job: {
      handler: function (newValue) {
        const {
          application_questions,
          application_disqualify_email
        } = newValue

        this.$emit('changed', {
          application_questions,
          application_disqualify_email
        })
      },
      deep: true
    },
    needApplicationDisqualifyEmail: {
      handler: function () {
        this.job.application_disqualify_email = {
          ...this.job.application_disqualify_email,
          enabled: false
        }
      },
      deep: true
    }
  },
  computed: {
    needApplicationDisqualifyEmail () {
      return this.job.application_questions.find(question => question.disqualify)
    }
  },
  methods: {
    setValuesFromInit () {
      const job = this.$clone(this.initJob)
      this.applicationQuestions = _.get(job, 'application_questions', [])
      this.enableApplicationDisqualifyEmail = _.get(job, 'application_disqualify_email', { enabled: false })
    },
    addItem () {
      if (!this.job.application_questions) {
        this.$set(this.job, 'application_questions', [])
      }

      this.job.application_questions.push({
        'label': '',
        'type': 'text',
        'options': []
      })
    },
    removeItem (index) {
      this.job.application_questions.splice(index, 1)
    },
    addOption (question) {
      question.push('')
    },
    removeOption (question, index) {
      question.options.splice(index, 1)
    },
    setTemplate (data) {
      this.job.application_questions = data.application_questions
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/JobForm/JobFormQuestions.vue